module.exports = __webpack_public_path__ + "images/skillz_placeholder-b272002d8330038cba964f1c6f0c7eb0.jpg";